import { DataTable, Table, TableBody, TableRow, TableCell, Button, FormLabel } from "carbon-components-react"
import { useEffect, useState } from "react"
import _ from "lodash"

const EditableList = (props) => {

    /**
     * Default values
     */
    const [values, setValues] = useState({
        "1": "1",
        "2": "2",
        "3": "3",
        "4": "4",
        "5": "5",
    })

    const [newValue, setNewValue] = useState("")

    /**
     * Set initial values id `defaultValue` is set
     */
    useEffect(() => {
        if (!_.isEmpty(props.defaultValue) &&
            !_.isNull(props.defaultValue) &&
            !_.isUndefined(props.defaultValue)
        ) {
            setValues(props.defaultValue)
        }
        else editValues(values)
    }, [])

    /**
     * Changes the value of a single row
     * @param {Event} e 
     * @param {String} index 
     */
    const editRow = (e, index) => {
        const value = e.target.value
        const newValues = {
            ...values,
            [index]: value
        }
        editValues(newValues)
    }

    /**
     * Add new row (already edited in "newValue")
     */
    const addRow = () => {
        const newIndex = _.kebabCase(newValue)
        const newValues = {
            ...values,
            [newIndex]: newValue
        }
        editValues(newValues)
        setNewValue("")
    }

    /**
     * Remove existing row by index
     * @param {String} index 
     */
    const removeRow = (index) => {
        let newValues = {}
        Object.keys(values).forEach(element => {
            if (element !== index) {
                newValues[element] = values[element]
            }
        })
        editValues(newValues)
    }

    /**
     * Set `values` state and fire `onChange` prop
     * @param {Object} newValues 
     */
    const editValues = (newValues) => {
        setValues(newValues)
        if (props.onChange) {
            props.onChange(newValues)
        }
    }

    const inputeStyle = {
        background: "none",
        border: 0,
        padding: 0,
        width: "100%"
    }

    let rows = []
    Object.keys(values).forEach(element => {
        rows.push({
            id: element,
            value: (
                <input
                    value={values[element]}
                    style={inputeStyle}
                    onChange={(e) => editRow(e, element)}
                />
            ),
            utility: (
                <div style={{ textAlign: "right" }}>
                    <Button kind="ghost" size="sm" onClick={() => removeRow(element)}>-</Button>
                </div>
            )
        })
    })
    rows.unshift({
        id: "add",
        value: (
            <input
                value={newValue}
                onChange={(e) => setNewValue(e.target.value)}
                style={inputeStyle} />
        ),
        utility: (
            <div style={{ textAlign: "right" }}>
                <Button kind="ghost" size="sm" onClick={() => addRow()} disabled={!newValue}>+</Button>
            </div>
        )
    })

    const label = (props.labelText) ? (
        <FormLabel>{props.labelText}</FormLabel>
    ) : null

    return (
        <>
            {label}
            <DataTable
                id={props.id}
                name={props.name}
                rows={rows}
                headers={[
                    { key: "value", header: "question" },
                    { key: "utility", header: "utility" }
                ]}
                size="compact"
            >
                {({ rows, getTableProps, getRowProps }) => (
                    <Table {...getTableProps()}>
                        <TableBody>
                            {rows.map((row) => (
                                <TableRow {...getRowProps({ row })}>
                                    {row.cells.map((cell) => (
                                        <TableCell key={cell.id}>{cell.value}</TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                )}
            </DataTable>
        </>
    )
}

export default EditableList